import clsx from 'clsx';
import Accordion from 'components/Accordion';
import RHFInput from 'components/Forms/RHFInput/RHFInput';
import LoadingIndicator from 'components/LoadingIndicator';
import { RootState } from 'pages/_store/root-reducer';
import { FC } from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';
import { PublicOffer, PublicOfferPricing } from 'types';
import OrderPageSelectors from '../../store/selectors';
import { useStyles } from '../FormContent.styles';
import { messages } from '../FormContent.translations';

const OfferResidualValueUpdateForm: FC = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { setValue, errors } = useFormContext<PublicOfferPricing>();
  const { isFetchingResult, order } = useSelector<
    RootState,
    {
      isFetchingResult: boolean;
      order: PublicOffer;
    }
  >(
    (state: RootState) => ({
      isFetchingResult: OrderPageSelectors.extractIsFetchingResult(state),
      order: OrderPageSelectors.extractOrder(state),
    }),
    shallowEqual
  );

  const orderDeactivated = !!order?.datetimeDeactivated;

  return (
    <div className={clsx('OfferResidualValueUpdateForm', classes.root)}>
      <LoadingIndicator isLoading={isFetchingResult}>
        <Accordion header={formatMessage(messages.FormContentResidualValueOverride)} collapsable={false}>
          <div className={classes.formRow}>
            <div className={classes.formColumn}>
              <RHFInput
                errorLabel={errors?.specialResidualValueOverride?.overrideReason}
                name="specialResidualValueOverride.overrideReason"
                label={formatMessage(messages.FormContentResidualValueOverrideReason)}
                disabled={orderDeactivated}
              />
            </div>
            <div className={classes.formColumn}>
              <RHFInput
                errorLabel={errors.specialResidualValueOverride as FieldError}
                name="specialResidualValueOverride.overridingResidualValues[0].residualValueAbsolute"
                label={formatMessage(messages.FormContentResidualValueOverride)}
                disabled={orderDeactivated}
                type="number"
                integer
              />
            </div>
            <div className={classes.formColumn} />
          </div>
        </Accordion>
      </LoadingIndicator>
    </div>
  );
};
export default OfferResidualValueUpdateForm;
